/**
 * 默认打印模板索引
 * 按单据类型名称加载对应的模板JSON
 */
import qgd from './请购单.json'
import cgdd from './采购订单.json'
import cgrk from './采购入库.json'
import cgth from './采购退货.json'
import xsd from './销售订单.json'
import xsc from './销售出库.json'
import xsth from './销售退货.json'
import lsc from './零售出库.json'
import lsth from './零售退货.json'
import qtr from './其它入库.json'
import qtc from './其它出库.json'
import dbc from './调拨出库.json'
import zzd from './组装单.json'
import zxd from './拆卸单.json'

// 中文名称 -> 模板JSON的映射
// 注意：所有"其他"统一使用"其它"
const defaultTemplates = {
  '请购单': qgd,
  '采购订单': cgdd,
  '采购入库': cgrk,
  '采购退货': cgth,
  '采购退货出库': cgth,
  '采购退货入库': cgth,
  '销售订单': xsd,
  '销售出库': xsc,
  '销售退货': xsth,
  '销售退货出库': xsth,
  '销售退货入库': xsth,
  '零售出库': lsc,
  '零售退货': lsth,
  '零售退货入库': lsth,
  '其它入库': qtr,
  '其它出库': qtc,
  '调拨出库': dbc,
  '组装单': zzd,
  '拆卸单': zxd,
}

// 代码 -> 中文名称的映射
// 注意：所有"其他"统一使用"其它"
const codeToNameMap = {
  'QGD': '请购单',
  'CGDD': '采购订单',
  'CGRK': '采购入库',
  'CGTH': '采购退货',
  'XSDD': '销售订单',
  'XSCK': '销售出库',
  'XSTH': '销售退货',
  'LSCK': '零售出库',
  'LSTH': '零售退货',
  'QTRK': '其它入库',
  'QTCK': '其它出库',
  'DBCK': '调拨出库',
  'ZZD': '组装单',
  'ZXD': '拆卸单',
}

// 中文名称 -> 代码的映射
const nameToCodeMap = {}
for (const [code, name] of Object.entries(codeToNameMap)) {
  nameToCodeMap[name] = code
}

/**
 * 根据单据类型名称获取默认模板
 * @param {string} billTypeName - 单据类型中文名称
 * @returns {Object|null} 模板JSON对象
 */
export function getDefaultTemplateByName(billTypeName) {
  return defaultTemplates[billTypeName] || null
}

/**
 * 根据单据类型代码获取默认模板
 * @param {string} billTypeCode - 单据类型代码 (如 CGDD)
 * @returns {Object|null} 模板JSON对象
 */
export function getDefaultTemplateByCode(billTypeCode) {
  const name = codeToNameMap[billTypeCode]
  if (name) {
    return defaultTemplates[name] || null
  }
  return null
}

/**
 * 根据单据类型代码获取中文名称
 * @param {string} billTypeCode - 单据类型代码
 * @returns {string} 中文名称
 */
export function getBillTypeName(billTypeCode) {
  return codeToNameMap[billTypeCode] || billTypeCode
}

/**
 * 根据中文名称获取单据类型代码
 * @param {string} billTypeName - 中文名称
 * @returns {string} 单据类型代码
 */
export function getBillTypeCode(billTypeName) {
  return nameToCodeMap[billTypeName] || billTypeName
}

/**
 * 获取所有支持的单据类型列表
 * @returns {Array} [{code, name}]
 */
export function getAllBillTypes() {
  return Object.entries(codeToNameMap).map(([code, name]) => ({ code, name }))
}

export { codeToNameMap, nameToCodeMap }
export default defaultTemplates
